<template>
  <div id="app" v-if="signedIn">
    <router-view />
  </div>
</template>
<script>
import Mgr from './assets/js/SecurityService';
export default {
  name: 'App',
  provide() {
    return {
      reload: this.reload
    };
  },
  data() {
    return {
      signedIn: true,
      mgr: new Mgr()
    };
  },
  methods: {
    // 刷新
    reload() {
      this.signedIn = false;
      this.$nextTick(() => {
        this.signedIn = true;
      });
    }
  },
  mounted() {}
};
</script>
<style>
.diyselect .el-select-dropdown__wrap {
  max-height: 360px;
}

.search-box {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  font-size: 14px;
  margin-top: 20px;
}

.search-box .item {
  margin-right: 10px;
  font-weight: bold;
  margin-bottom: 10px;
}

.search-box .item.w1 {
  width: 120px;
}

.tips {
  font-size: 14px;
  margin-top: 15px;
  margin-bottom: 15px;
}

.pagination {
  text-align: center;
  margin: 20px 0;
}
</style>
<style lang="scss" scoped>
#app {
  height: 100%;
  width: 100%;
}
</style>
